import { createSelector } from "@reduxjs/toolkit";
import { AvailableLanguage } from "@tecma/ds/lib/components/LanguageSelector/constants";
import type { RootState } from "../..";

export const isLoadingSelector = createSelector(
  (state: RootState) => state.applicationState,
  (state) => state.isLoading,
);

export const getAvailableLanguagesSelector = createSelector(
  (state: RootState) => state.applicationState,
  (state) =>
    state.projectInfo?.languages || (["it-IT", "en-GB"] as AvailableLanguage[]),
);

export const getProjectIDSelector = createSelector(
  (state: RootState) => state.applicationState,
  (state) => state.projectInfo?.id,
);
export const getProjectInfoSelector = createSelector(
  (state: RootState) => state.applicationState,
  (state) => state.projectInfo,
);

export const getMyAccount = createSelector(
  (state: RootState) => state.applicationState,
  (state) =>
    state.projectInfo?.enabledTools?.find((tool) => tool.name === "MyAccount"),
);

export const getMyHome = createSelector(
  (state: RootState) => state.applicationState,
  (state) =>
    state.projectInfo?.enabledTools?.find((tool) => tool.name === "MyHome"),
);

export const getRentConstraintsSelector = createSelector(
  (state: RootState) => state.applicationState,
  (state) => state.projectInfo?.rentConstraints,
);

export const getProjectLogoSelector = createSelector(
  [
    (state: RootState) => state.applicationState,
    (state: RootState) => state.environmentState,
  ],
  (applicationState, environment) => {
    return `${environment.REACT_APP_BUCKET_BASEURL}/initiatives/${encodeURI(
      applicationState.projectInfo?.displayName ?? "",
    )}/global/img/logo192.png`;
  },
);

export const getProjectAreaSelector = createSelector(
  (state: RootState) => state.applicationState,
  (state) => state.projectInfo?.area,
);

export const getProjectContactsSelector = createSelector(
  (state: RootState) => state.applicationState,
  (state) => ({
    email: state.projectInfo?.contactEmail,
    phone: state.projectInfo?.contactPhone,
  }),
);

export const getProjectDisplayNameSelector = createSelector(
  (state: RootState) => state.applicationState,
  (state) => state.projectInfo?.displayName,
);

export const getShowNewUserModalSelector = createSelector(
  (state: RootState) => state.applicationState,
  (state) => state.showNewUserModal,
);

export const getRoomSelectorConfigurationSelector = createSelector(
  (state: RootState) => state.applicationState,
  (state) => state.roomSelectorConfiguration,
);

export const applicationStateSelectors = {
  selectProjectInfo: getProjectInfoSelector,
  selectIsLoading: isLoadingSelector,
  availableLanguages: getAvailableLanguagesSelector,
  rentConstraints: getRentConstraintsSelector,
  projectID: getProjectIDSelector,
  contacts: getProjectContactsSelector,
  logo: getProjectLogoSelector,
  displayName: getProjectDisplayNameSelector,
  area: getProjectAreaSelector,
  myAccount: getMyAccount,
  myHome: getMyHome,
  showNewUserModal: getShowNewUserModalSelector,
  roomSelectorConfiguration: getRoomSelectorConfigurationSelector,
};
